<template>
  <div>
<!--    <h1>Login</h1>-->
    <button v-on:click="federatedSignIn('Facebook')">Open Facebook</button>
  </div>
</template>

<script>
import {Auth} from 'aws-amplify';

export default {
  name: "sso",
  components: {
  },
  methods : {
    federatedSignIn(provider) {
      Auth.federatedSignIn({ provider });
      console.log(provider);
      // <!--        <button onClick={() => Auth.federatedSignIn({provider: 'Facebook'})}>Open Facebook</button>-->

    }
  }
}
</script>

<style scoped>

</style>
